// src/pages/About.jsx
import React from 'react';
import { useTranslation } from '../context/TranslationContext';
import aboutImage from '../images/team1.jpg';
export default function About() {
  const { t } = useTranslation();

  return (
    <section id="about" className="py-12 bg-gray-50">
      <div className="container mx-auto flex flex-col-reverse md:flex-row items-center px-4 sm:px-6 md:px-8">
        {/* Texto */}
        <div className="w-full md:w-1/2 mt-8 md:mt-0">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-800 mb-4">
            {t('about_title')}
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-gray-600 mb-6 leading-relaxed">
            {t('about_description')}
          </p>
          <a
            href="/services"
            className="inline-block px-6 py-3 text-base sm:text-lg font-semibold bg-primary text-white rounded-lg hover:bg-primary-dark transition"
          >
            {t('about_cta')}
          </a>
        </div>

        {/* Imagen */}
        <div className="w-full md:w-1/2 flex justify-center">
          <img
            src={aboutImage}
            alt={t('about_image_alt')}
            className="w-full max-w-md h-auto rounded-lg shadow-lg"
          />
        </div>
      </div>
    </section>
  );
}
